import { type Project, type ProjectId, ROLE_COLLABORATOR, ROLE_OWNER } from "@storytell/types";
import type { Wire } from "~/wire/definition";

/**
 * Every project except the current one that the user may move or copy content
 * into — assets, skills, chats and live sessions all land through this list.
 *
 * The test is the user's role in the destination, not the project's own
 * `op.create` grant: that grant belongs to owners alone, while each resource a
 * move or copy writes — chats, assets, skills, live sessions — grants create to
 * collaborators too, so the grant alone hides destinations the backend accepts.
 * It stays as a fallback because an update response carries a project's grants
 * without its role until the next sync.
 */
export function getAvailableProjectsForAssetOperations(
  wire: { projects: Pick<Wire["projects"], "all" | "canCreate"> },
  currentProjectId: ProjectId
): Project[] {
  return wire.projects
    .all()
    .filter((p: Project) => p.id !== currentProjectId)
    .filter((p: Project) => p.role === ROLE_OWNER || p.role === ROLE_COLLABORATOR || wire.projects.canCreate(p.id));
}
